export const ComputersStore = {
    namespaced: true,
    state: {
        computers: [],
        computer: {},
        computersAvailableGroup: {},
        computersAvailableSchedule: {}
    },
    mutations: {
        setComputers(state: any, response: any) {
            state.computers = response;
        },
        setComputer(state: any, response: any) {
            state.computer = response;
        },
        setComputersAvailable(state: any, response: any) {
            state.computersAvailableGroup = response;
        },
        setComputersAvailableSchedule(state: any, response: any) {
            state.computersAvailableSchedule = response;
        }
    },
    actions:{
        setComputers(context: any, response: any) {
            context.commit('setComputers', response);
        },
        setComputer(context: any, response: any) {
            context.commit('setComputer', response);
        },
        setComputersAvailable(context: any, response: any) {
            context.commit('setComputersAvailable', response);
        },
        setComputersAvailableSchedule(context: any, response: any) {
            context.commit('setComputersAvailableSchedule', response);
        }
    },
    getters: {
        getComputers: (state: any) => state.computers,
        getComputer: (state: any) => state.computer,
        getComputersAvailable: (state: any) => state.computersAvailableGroup,
        getComputersAvailableSchedule: (state: any) => state.computersAvailableSchedule
    }
};